<template>
    <div>
        <div
            v-if="value"
            v-html="value"
            :id="shortened ? '' : 'longDescription'"
            class="text-styles"
        ></div>

        <a
            v-if="shortened && value.length > maxLength"
            @click="scrollToLongDescription()"
            class="d-block font-weight-bold text-underline short-description-more"
        >
            {{$language.translate('more product info >')}}
        </a>

        <v-layout
            row
            wrap
            class="align-start pt-2"
            :class="textColor + '--text'"
            v-if="attributes"
        >
            <v-flex xs12 md12 v-for="attributesRow in attributes">
                <v-layout row wrap>
                    <template v-for="(attribute, indexname, index) in attributesRow">
                        <v-flex
                            xs6
                            class="font-weight-bold py-0"
                            :key="'public-attribute-name-' + index"
                        >
                            <v-layout row wrap align-center ma-0>
                                <v-flex xs10 class="pa-0">
                                    {{ attribute.name }}
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6 :key="index" class="py-0">
                            <div
                                v-for="(valueName, valueKey, index) in getIterableValue(attribute.value)"
                                :key="'public-attribute-value-' + index"
                            >
                                <div v-html="valueName" class="text-styles"></div>
                            </div>
                        </v-flex>
                    </template>
                </v-layout>


            </v-flex>

        </v-layout>
    </div>
</template>

<style>
.short-description-more {
    color: inherit;
}
.text-styles p {
    margin-bottom: 0;
}

.text-styles ul, ol {
    padding-left: 0;
}

.text-styles li {
    padding-bottom: 3px;
}

.text-styles br {
    display: none;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ProductLongDescription } from './product-page/ProductLongDescription.vue';

const parentModuleName = 'Product';
const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'ProductLongDescription',
    extends: ProductLongDescription,
    props: {
        shortened: Boolean,
        maxLength: {
            type: Number,
            default: 250,
        },
        attributes: {
            type: Object | Array,
            default: () => ({}),
        },
        additions: {
            type: Object,
            default: () => ({}),
        },
        limit: {
            type: Number,
        },
        textColor: String,
        cols: {
            default: 1,
        },

    },
    computed: {
        value() {
            let value = this.getProductAttributeByLanguage(this.product, 'product.description.long');

            if (this.shortened && this.maxLength) {
                value = value.substring(0, this.maxLength) + (value.length > this.maxLength ? '...' : '');
            }

            return value;
        },
        ...mapState(['product']),
        ...mapGetters(['getProductAttributeByLanguage']),
    },
    methods: {
        scrollToLongDescription() {
            let container = document.querySelector("#longDescription");
            if (typeof container.scrollIntoView === 'function') {
                const offset = document.getElementsByTagName('header')[0].offsetHeight;
                const y = container.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({top: y, behavior: 'smooth'});
            } else {
                window.scrollTo(0, container.scrollTop);
            }
        },
        getIterableValue(value) {
            var result = {};
            if (typeof value == 'string') {
                result = {
                    [value]: value,
                };
            } else if (Array.isArray(value)) {
                result = new Object(value);
            } else if (value != undefined && value != null) {
                result = value;
            }

            return result;
        },
        attributesByColumns() {
            let result = {};
            let column = 1;
            if (this.languageAttributes) {
                Object.keys(this.languageAttributes).forEach(key => {
                    if (!result[column]) {
                        result[column] = {};
                    }

                    result[column][key] = this.languageAttributes[key];

                    if (column < this.cols) {
                        column++;
                    } else {
                        column = 1;
                    }
                });
            }

            return result;
        },
        languageAttributes() {
            const lang = this.$language.getLanguage();
            let attributes = {};
            let result = {};

            if (this.attributes && this.attributes[lang]) {
                attributes = this.attributes[lang];
            } else if (this.attributes && Object.values(this.attributes).length > 0) {
                attributes = Object.values(this.attributes)[0];
            }

            if (this.limit) {
                Object.keys(attributes).some((key, index) => {
                    if (index + 1 <= this.limit) {
                        result[key] = attributes[key];
                    } else {
                        return true;
                    }
                });
            } else {
                result = attributes;
            }

            return result;
        },
    },
};
</script>
